import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface ToggleButtonGroupCSSStyle extends UIComponentCSSStyle
{
  getTabHeaderCSSStyle(): object; 
}

export class ToggleButtonGroupCSSStyleImpl extends UIComponentCSSStyleImpl implements ToggleButtonGroupCSSStyle 
{ 
  getTabHeaderCSSStyle(): object 
  {
      return {
          // height: "40px",
          width: "auto",
          boxSizing: "border-box",
          backgroundColor: "#EAEDF0",
          borderRadius: "10px",
          // display: "flex",
          border: "1px solid #EAEDF0",
          position: "relative",
          // flexDirection: "row",
          // flexFlow: "row wrap",
      };
  }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/togglebuttongroup/togglebuttongroupcss.tsx